import lateNightPages from './late-night-pages.json';
import morningCommuteGroove from './morning-commute-groove.json';
import bossaSidewalk from './bossa-sidewalk.json';
import dorianJazzCafe from './dorian-jazz-cafe.json';

export const LOFI_CHARTS = {
  [lateNightPages.id]: lateNightPages,
  [morningCommuteGroove.id]: morningCommuteGroove,
  [bossaSidewalk.id]: bossaSidewalk,
  [dorianJazzCafe.id]: dorianJazzCafe
};

export const LOFI_CHART_LIST = Object.values(LOFI_CHARTS);
